// @ts-nocheck
import React from 'react';
import { useParams } from 'react-router-dom';
import CheckinSummaryPublicView from '@/components/checkin/CheckinSummaryPublicView';

interface CheckinSheetPageProps {
  tokenOverride?: string;
  embedded?: boolean;
}

const CheckinSheetPage: React.FC<CheckinSheetPageProps> = ({ tokenOverride, embedded }) => {
  const { token: paramToken } = useParams<{ token: string }>();
  const token = tokenOverride || paramToken;

  return (
    <div className={embedded ? '' : 'min-h-screen bg-background'}>
      <CheckinSummaryPublicView token={token} />
    </div>
  );
};

export default CheckinSheetPage;
